import React from "react";
import { range } from "../../utils/array-utils";
import MachineGroupIcon from "../../assets/icons/search-screen-machine-group-icon.png";

const SearchGroupsInformation = ({ groupSettings, searchInformation }) => {
  return (
    <div className="xl:pl-4 pl-3 pr-2 py-2 bg-white rounded-lg flex items-center w-auto border border-gray-tenken-300">
      {range(1, 5).map(
        (level) =>
          groupSettings &&
          groupSettings[`group_${level}`]?.active && (
            <div key={level} className="flex flex-col mr-4">
              <label className="text-tenken-gray-700 whitespace-nowrap">
                {groupSettings[`group_${level}`].name}
              </label>
              <span className="font-bold mt-1 truncate lg:max-w-[240px] max-w-[228px]">
                {searchInformation && searchInformation[`group_${level}`]}
              </span>
            </div>
          )
      )}
      <div className="w-[40px] h-[52px]">
        <img src={MachineGroupIcon} alt="group" className="w-[40px] h-[52px]" />
      </div>
    </div>
  );
};

export default SearchGroupsInformation;
